import { get_media } from '../../api/api'
import poster from '../../no_poster.png'

const GetPoster = ({ id }) => {

     const img = id ? get_media(id) : ''

     return (
          <div
               className='posterItem'
               style={{
                    backgroundImage: `url(${img ? img : poster})`
               }}
          ></div>
     )
}

export default GetPoster